{
  "pending": "čeká na vyřízení"
}
